/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";

import Constants from "app_constants";
import Theme from "./theme";

const options = [
  { value: "small", label: "1-10" },
  { value: "medium", label: "10-100" },
  { value: "large", label: "100-500" },
  { value: "xLarge", label: "500-1000" },
  { value: "xxLarge", label: "1000+" },
];

const renderAccountDeleteModal = (modalActive, showModal, deleteAccount) => {
  return (
    <div className={`modal${modalActive ? " is-active" : ""}`}>
      <div onClick={() => showModal(false)} className="modal-background"></div>
      <div className="modal-card">
        <section className="modal-card-body">
          <h1 className="title">
            <i className="fas fa-check successIcon"></i> Delete Account
          </h1>
          <h2 className="subtitle modalContent">
            Do you really want to delete your account?
          </h2>
          <div className="field is-grouped is-pulled-right">
            <p className="control">
              <a className="button is-danger" onClick={() => showModal(false)}>
                Cancel
              </a>
              &nbsp; &nbsp;
              <a
                className="button is-link"
                onClick={() => {
                  showModal(false);
                  deleteAccount();
                }}
              >
                Delete Account
              </a>
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

const DashboardView = (props) => {
  const {
    mode,
    selectMode,
    jobs,
    deleteAccount,
    accountDeleteModal,
    showAccountDeleteModal,
    setFormData,
    logo,
    editAccount,
    type,
    forms,
  } = props;

  return (
    <Theme>
      {renderAccountDeleteModal(
        accountDeleteModal,
        showAccountDeleteModal,
        deleteAccount
      )}

      {Constants.metaTag}

      <div className="columns">
        <div className="column is-3 box">
          <aside className="menu">
            {type === "company" && (
              <Fragment>
                <p className="menu-label">General</p>
                <ul className="menu-list">
                  <li>
                    <a onClick={() => selectMode("jobAds")}>Job Ads</a>
                  </li>
                  <li>
                    <a onClick={() => selectMode("forms")}>Forms</a>
                  </li>
                </ul>
              </Fragment>
            )}
            <p className="menu-label">Account</p>
            <ul className="menu-list">
              <li>
                <a onClick={() => selectMode("editAccount")}>Edit Account</a>
              </li>
              <li>
                <a onClick={() => showAccountDeleteModal(true)}>
                  Delete Account
                </a>
              </li>
            </ul>
          </aside>
        </div>

        <div className="column is-9">
          {mode === "jobAds" && (
            <div className="box">
              {jobs.length === 0 ? (
                <p>You didn't add any job ad yet!</p>
              ) : (
                <table className="table is-fullwidth">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Category</th>
                      <th className="has-text-right">Edit Job Ad</th>
                    </tr>
                  </thead>

                  <tbody>
                    {jobs.map((job) => (
                      <tr>
                        <td>{job.title}</td>
                        <td>{Constants.jobCategories[job.category]}</td>
                        <td className="has-text-right">
                          <Link to={`/publish-job?id=${234234}`}>
                            <button className="button is-info is-small">
                              Edit
                            </button>
                          </Link>
                        </td>
                      </tr>
                    ))}
                    {jobs.length === 0 && (
                      <p>You haven't added any job ad yet!</p>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          )}

          {mode === "forms" && (
            <div className="box">
              {forms.length === 0 ? (
                <p>You didn't add any form yet!</p>
              ) : (
                <table className="table is-fullwidth">
                  <thead>
                    <tr>
                      <th>Form Name</th>
                      <th>Date</th>
                      <th className="has-text-right">Edit Form</th>
                    </tr>
                  </thead>

                  <tbody>
                    {forms.map((job) => (
                      <tr>
                        <td>erer</td>
                        <td>12.08.2019 17:54</td>
                        <td className="has-text-right">
                          <button className="button is-info is-small">
                            Edit
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          )}

          {mode === "editAccount" && (
            <Fragment>
              <h4 className="title is-4">Edit Account</h4>
              <input
                className="input is-info"
                type="email"
                placeholder="Company Name"
              />
              <br /> <br />
              <input
                className="input is-info"
                type="email"
                placeholder="Company Location"
              />
              <br /> <br />
              <input
                className="input is-info"
                type="email"
                placeholder="Company Web Site"
              />
              <br /> <br />
              <Select
                options={options}
                onChange={(e) => {
                  setFormData("companySize", e.value);
                }}
                placeholder="Company Size"
              />
              <br />
              <div className="file has-name">
                <label className="file-label">
                  <input
                    onChange={(e) => {
                      setFormData("logo", e.target.files[0]);
                    }}
                    className="file-input"
                    type="file"
                    name="resume"
                  />
                  <span className="file-cta">
                    <span className="file-icon">
                      <i className="fas fa-upload"></i>
                    </span>
                    <span className="file-label">Select Logo…</span>
                  </span>
                  {logo && <span className="file-name">{logo}</span>}
                </label>
              </div>
              <br /> <br />
              <button
                onClick={editAccount}
                className="button is-info is-fullwidth submit"
              >
                Submit
              </button>
            </Fragment>
          )}
        </div>
      </div>
    </Theme>
  );
};

export default DashboardView;
